import { DatePipe, DOCUMENT, Location } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, QueryList, Renderer2, RendererStyleFlags2, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDateService, NbDialogService, NbPopoverDirective } from '@nebular/theme';
import html2canvas from 'html2canvas';
import jspdf from 'jspdf';
import { NgxPrintElementService } from 'ngx-print-element';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { last, takeUntil } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { RolesData } from '../../../../@core/interfaces/common/roles';
import { AdmissionMasterData } from '../../../../@core/interfaces/Ip/admissionMaster';
import { DischargeTmplData } from '../../../../@core/interfaces/masters/discharge-tmpl';
import { imageatch_detData } from '../../../../@core/interfaces/masters/imageatch_det';
import { PrinterSettings, PrinterSettingsData } from '../../../../@core/interfaces/masters/printersettings';
import { TenantBranchData } from '../../../../@core/interfaces/masters/tenantbranch';
import { UpiPaymentMst, UpiPaymentMstData } from '../../../../@core/interfaces/masters/UpiPaymentMst';
import { PatientRegistrationData } from '../../../../@core/interfaces/patient-services/patient-registration';
import { DateService } from '../../../../@theme/components/common/service/date.service';
import { PrintServiceService } from '../../../../@theme/components/common/service/print-service.service';
import { commonsettings } from '../../../../data/ezoTempSettings';
import { PhysicianData } from './../../../../@core/interfaces/masters/physician-mst';
import { SummaryData, SummaryFields, SummaryMst } from './../../../../@core/interfaces/patient-services/summary';
import * as title from './../../../../data/title.json';
import { NumberToWordsPipe } from '../../../../@theme/pipes/numberToWords.pipe';
// import { OpbillTemplateThermalPrintComponent } from '../opbill-template-thermal-print/opbill-template-thermal-print.component';
import { mailSeriveApi } from '../../../../@core/backend/common/api/mailService.api';
import { PdfToBlobService } from '../../../../pages/pdf-to-blob.service';
@Component({
  selector: 'ngx-common-template-print',
  templateUrl: './common-template-print.component.html',
  styleUrls: ['./common-template-print.component.scss']
})
export class CommonTemplatePrintComponent implements OnInit {
  @Input() selectedtemplateData: Array<any> = [];
  @Input() billData: any;
  @Output() replaceHeaderValueCall = new EventEmitter<void>();
  replacedHeaderValue: any;
  @Output() replaceTableValueCall = new EventEmitter<any>();
  replacedTableValue: string;
  tableDisplayCondition: boolean;
  tableEditorCondition: boolean;
  @Output() replaceDetailsValueCall = new EventEmitter<any>();
  replacedDetailsValue: string;
  detailsDisplayCondition: boolean;
  detailsEditorCondition: boolean;
  totalamount: any;
  admissionId: any;
  visitId: any;
  regId: any;
  @Input() upireferrence:number;
  @Input() cardreferrence:number;
  @Input() chequereferrence:number;
  @Input() netBankingreferrence:number;
  data: any = [];
  tempId: string;
  sumMstData: any = [];
  // cetMstArray:Array<any>=[];
  p: number = 1;
  isEditComponnet: boolean = false;
  isAddComponnet: boolean = false;
  term: string;
  protected readonly unsubscribe$ = new Subject<void>();
  // private tenandId = environment.tenandId;
  // private branchId = environment.branchId;
  private tenandId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  private createdBy = localStorage.getItem("userId");

  placeholder: string = "Select";
  allowClear: any = true;
  multiple: boolean = false;
  detForm: FormGroup;
  fields: SummaryFields[];
  dupTitle: boolean;
  printCertificateTitle: boolean;
  selected: SummaryMst;

  isBtnSubmitted: boolean = false;
  printmsg: boolean = false;
  errorLabel: boolean = false;
  saveMsg: boolean = false;
  save_discharge_summary: boolean = false;
  update_discharge_summary: boolean = false;
  cancel_summary: boolean = false;
  @Input("dynamicVal") dynamic: boolean = false;
  @Input() fromMst: boolean = false;
  patDet: any;
  multiSelectFields: SummaryFields[];
  dynamicFieldsList: SummaryFields[] = [];
  templateData: any;

  visitDoctorid: any;
  visitDoctor: string;
  admissionDetails: any;
  visitDoctorDeptId: any;

  srcname = !!localStorage.getItem('TenantHospitalImg') ? localStorage.getItem('TenantHospitalImg') : '/assets/images/white.png';
  fontStyleLists = commonsettings.font_style_lists;
  commonSettings = commonsettings.template;
  tempdecSettings = commonsettings.body

  templateForm: FormGroup;
  fontdialogForm: FormGroup;
  templatePreview: any;
  topHeaderLines: FormArray;
  bodyItemLines: FormArray;
  FooterLines: FormArray;
  commonStylechange = "";

  pageTitleList: any = [];
  pageTitleSetttings: any = JSON.parse(JSON.stringify(commonsettings.template?.page_title))
  objectKeys = Object.keys;
  itemBodyList: any = [];

  docname2;
  patientid;
  patientmno;
  patientname;

  duplicateMsg: boolean;
  erroeSavemsg: boolean;
  savedSuccessMsg: boolean;
  duplicateDischarge: boolean;
  savedSettingMsg: boolean;
  isSubmitted: boolean;
  editDischargeData: any;
  onloadeditdata: any;
  cancelDialog: boolean = false;
  onPreviewDialog: boolean = false;
  currenteditorindex;
  selectsummarymst: any;
  loadText = "Updates are in progress. Please wait";
  private tenantId = localStorage.getItem("tenantId");
  @ViewChild(NbPopoverDirective) popover: NbPopoverDirective;
  @ViewChildren(NbPopoverDirective) popovers: QueryList<NbPopoverDirective>;
  // @ViewChild('printtemplatesetting') SaleThermalPrintTemplate: OpbillTemplateThermalPrintComponent;
  totallineitemsdiscount: any;
  gstshowstatus: boolean = false;
  taxableAmount: any;
  totaltaxableAmount: number;
  gstamount: number;
  upiPaymentList: UpiPaymentMst[];
  insList: Array<any> = [];
  dissumamry1: any = [];
  dissumamry2: any = [];
  pagenumber: number = 1;
  totaltaxamount: number;
  taxdetails: Array<any> = [];
  timeFormat: string;
  timeSymbol: string;
  dateFormatVal: string;
  public config = {
    printMode: 'template-popup',
    popupProperties: 'toolbar=yes,scrollbars=yes,resizable=yes,top=0,left=0,fullscreen=yes',
    pageTitle: 'OP Bill',
    // templateString: '<header>I\'m part of the template header</header>{{printBody}}<footer>I\'m part of the template footer</footer>',
    stylesheets: [{ rel: 'stylesheet', href: '/assets/css/print.css' }, { rel: 'stylesheet', href: '/assets/css/custom.css' }, { rel: 'stylesheet', href: 'https://maxcdn.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css' },
    ],
    styles: [
      commonsettings.printCommonStyle
    ]
  };
  itemvalue: any = [];
  editorConfig: any = {
    width: 'auto',
    height: 100,
    plugins:
      'print preview fullpage searchreplace autolink \
         directionality visualblocks visualchars fullscreen \
         image imagetools  media  table template codesample preview \
         charmap hr pagebreak nonbreaking anchor insertdatetime \
         advlist lists textcolor wordcount contextmenu colorpicker textpattern autoresize link image code',
    toolbar:
      'fontselect bold italic forecolor fontsizeselect strikethrough backcolor \
         alignleft aligncenter alignright alignjustify table lineheight \
         numlist bullist outdent indent preview fullscreen code  ',
    image_advtab: true,
    imagetools_toolbar:
      'rotateleft rotateright | flipv fliph | editimage imageoptions',
    toolbar_location: 'bottom',
    statusbar: false,
    toolbar_mode: 'floating',
    menubar: false,
    content_security_policy: "default-src 'self'",
    nonbreaking_force_tab: true,
    setup: function (editor) {
      editor.on('init', function (e) {
      });
    },
    init_instance_callback: function (editor) {
      editor.on('ExecCommand', function (e) {
        if ("LineHeight" == e.command) {
        }
      });
    }
    // superscript subscript anchor
  };
  titleList: any = (title as any).default;

  changeThemeNotifyDialog: boolean = false;
  @ViewChild('printcontent', { static: false }) printcontent: ElementRef;
  @ViewChild('downloadpdf') downloadpdf: ElementRef;
  downloadHtml = '';
  countryDet: any = localStorage.getItem("LoginCountryDet") ? JSON.parse(localStorage.getItem("LoginCountryDet")) : '';

  loadPer: number;
  showPer: boolean = false;
  mailErrMsg: boolean = false;
  mailSuccessMsg: boolean = false;
  isMailnotExists: boolean = false;
  @Input() patientName: string;
  @Input() patientDetails: any;
  @Input() isMailShare: boolean = false;
  @Input() psDetails: PrinterSettings;
  @Input() billNumber: string;
  customerName: string = localStorage.getItem("customerName");
  isNoMailCreditBal: boolean = false;
  isMailnotActivated: boolean = false;
  @Input() mailActivationFlag: boolean;
  @Input() mailCreditBalance: boolean;
  isSuperAdmin: boolean = localStorage.getItem('isSuperUser') ? true : false;
  thermalSize: number;

  constructor(public dateobj: DateService, protected upiPaymentSrvc: UpiPaymentMstData,
    // printer settings constructor object create start by RAJA:)
    private iatchSrvc: imageatch_detData,
    protected psSrvc: PrinterSettingsData,
    public PrintServiceService: PrintServiceService,
    @Inject(DOCUMENT) public document: any,
    // printer settings constructor object create end by RAJA:)
    public datesrcv: DateService,
    private elementRef: ElementRef,
    public location: Location, public spinner: NgxSpinnerService,
    protected phySrvc: PhysicianData, protected rolesService: RolesData, private changeDetectorRef: ChangeDetectorRef, private fb: FormBuilder, private sumSrvc: SummaryData,
    private datePipe: DatePipe, protected dateService: NbDateService<Date>, private route: ActivatedRoute, public sanitizer: DomSanitizer,
    protected patRegSrvc: PatientRegistrationData, private router: Router, private renderer: Renderer2, protected tenantBrchSrvc: TenantBranchData, private dialogService: NbDialogService, public printsrvc: NgxPrintElementService, private admissionMasterService: AdmissionMasterData, protected DischargeTmplSrvc: DischargeTmplData,
    private pdfBlobSrvc: PdfToBlobService, private mailSrvc: mailSeriveApi) {
    this.detForm = this.generateForm();
    this.route.params.subscribe(params => {
      this.regId = params['regId'];
      this.admissionId = params['admissionId'];
    });
    this.fontdialogForm = this.fb.group({
      elementVal: this.fb.control(null),
      fontfamily: this.fb.control(this.commonSettings?.fontfamily),
      fontColor: this.fb.control('#333333'),
      fontSize: this.fb.control(12),
      isBold: this.fb.control(false),
      isItalic: this.fb.control(false),
      isUnderline: this.fb.control(false),
      linespace: this.fb.control(1),
      textAlign: this.fb.control("left"),
      outdent: this.fb.control(0),
      indent: this.fb.control(0),
      textheight: this.fb.control(1)
    });
    this.templateForm = this.fb.group({
      //Template prop
      templatename: this.fb.control(null, [Validators.required,],),
      tmplCommonFlag: this.fb.control(null),
      tmplReportHeader: this.fb.control(null),
      tmplReportFooter: this.fb.control("Header"),
      tmplDisplayDept: this.fb.control("Footer"),
      tmplDisplayPhy: this.fb.control(null),
      tmplDisplaySettings: this.fb.control(null),
      tmplActiveFlag: this.fb.control(null),
      ps: this.fb.control('A4', [Validators.required,],),
      orientation: this.fb.control('Portrait', [Validators.required,],),
      lm: this.fb.control(10, [Validators.required],),
      rm: this.fb.control(10, [Validators.required],),
      tm: this.fb.control(10, [Validators.required],),
      bm: this.fb.control(10, [Validators.required],),
      id: this.fb.control(null),
      height: this.fb.control(null),
      width: this.fb.control(null),
      bgColor: this.fb.control('#ffffff'),
      labelColor: this.fb.control('#333333'),
      fontColor: this.fb.control('#333333'),
      fontSize: this.fb.control(12),
      fontfamily: this.fb.control(this.commonSettings?.fontfamily),
      imagewidth: this.fb.control(60),
      temptype: this.fb.control(null),
      //Header
      topHeaderRequired: this.fb.control(true),
      topHeaderLogoRequired: this.fb.control(true),
      topHeaderLogoPosition: this.fb.control('center start'),
      topHeaderPosition: this.fb.control('center end'),
      topHeaderheight: this.fb.control(60),
      topHeaderlineheight: this.fb.control(18),
      topHeaderLines: new FormArray([]),
      topheaderbgColor: this.fb.control('#ffffff'),
      topheaderfontColor: this.fb.control('#333333'),
      topheaderfontfamily: this.fb.control(this.commonSettings?.fontfamily),
      pageTitle: this.fb.control('Discharge Summary'),
      pageTitlefontsize: this.fb.control(14),
      reportHeaderPlacement: this.fb.control('center center'),
      pageTitleHeaderRequired: this.fb.control(true),
      watermark: this.fb.control(false),
      watermarkPosition: this.fb.control('center end'),
      //
      pageTitleData: this.fb.control(true),
      // Body Table
      bodyItemLines: new FormArray([]),
      bodyHeader: this.fb.group({
        itemname: this.fb.control(1),
        itemvalue: this.fb.control(null),
        itemfontfamily: this.fb.control(this.commonSettings.fontfamily),
        itemfontcolor: this.fb.control(this.commonSettings.fontColor),
        itemfontsize: this.fb.control(this.commonSettings.fontSize),
        itemisdisplay: this.fb.control(true),
        itemposition: this.fb.control('Left'),
        itemismandatory: this.fb.control(false),
        itemtype: this.fb.control('Body'),
      }),
      bodyValue: this.fb.group({
        itemname: this.fb.control(1),
        itemvalue: this.fb.control(null),
        itemfontfamily: this.fb.control(this.commonSettings.fontfamily),
        itemfontcolor: this.fb.control(this.commonSettings.fontColor),
        itemfontsize: this.fb.control(12),
        itemisdisplay: this.fb.control(true),
        itemposition: this.fb.control('Left'),
        itemismandatory: this.fb.control(false),
        itemtype: this.fb.control('Body'),
      }),

      tblrow: this.fb.control(1),
      tblcol: this.fb.control(1),
      bodylayout: this.fb.control('Top Bottom'),
      //Footer
      FooterRequired: this.fb.control(null),
      FooterLogoRequired: this.fb.control(null),
      FooterLogoPosition: this.fb.control(null),
      FooterPosition: this.fb.control(null),
      Footerheight: this.fb.control(60),
      Footerlineheight: this.fb.control(18),
      FooterLines: new FormArray([]),
      FooterbgColor: this.fb.control('#ffffff'),
      FooterfontColor: this.fb.control('#333333'),
      Footerfontfamily: this.fb.control(this.commonSettings?.fontfamily),
      bottomDocsignrequired: this.fb.control(null),
      bottomDocsignPosition: this.fb.control('center end'),
      bottomDocsignLabel: this.fb.control('Dr Name'),
      bottomDocsignLabelsize: this.fb.control(12),
      bottomDocsignimg: this.fb.control(null),
      bottomDocsignftcol: this.fb.control('#000000'),

      FooterLine1: this.fb.control(null),
      FooterLine2: this.fb.control(null),
      FooterLine3: this.fb.control(null),
      FooterLine4: this.fb.control(null),
      reportHeader: this.fb.control(null),
      reportFooter: this.fb.control(null),
    });
    this.fontdialogForm.valueChanges.subscribe(data => this.onFontDialogValueChanged(data));
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    let templateData = this.selectedtemplateData.find(x => x.defaultFlag == "Y")
    setTimeout(() => {
      this.setDefultTemplate(templateData);
    }, 1000);
  }
  setDefultTemplate(templateData) {
    if (!!templateData && templateData != undefined) {
      this.tempId = templateData.id;
      this.detForm.controls['fieldsSelect'].setValue(this.tempId);
      this.onChange([{ data: templateData }])

      this.thermalSize = 0;
    }
  }
  setDynamicHeaderData(replacedHeaderValue: any) {
    this.replacedHeaderValue = replacedHeaderValue;
    if (!!this.replacedHeaderValue?.value) {
      this.replacedHeaderValue.value = this.replacedHeaderValue.value
        .replace((new RegExp("{referrenceNo}", "g")), this.getReferrence());
    }
  }

  setDynamicTableData(replacedTableValue, tableDisplayCondition, tableEditorCondition) {
    this.replacedTableValue = replacedTableValue;
    this.tableDisplayCondition = tableDisplayCondition;
    this.tableEditorCondition = tableEditorCondition;
  }

  setDynamicDetailsData(replacedDetailsValue, detailsDisplayCondition, detailsEditorCondition) {
    this.replacedDetailsValue = replacedDetailsValue?.replace(
      (new RegExp("{referrenceNo}", "g")),
      this.getReferrence()
    );
    this.detailsDisplayCondition = detailsDisplayCondition;
    this.detailsEditorCondition = detailsEditorCondition;
  }

setWidth(): void {
  const tmplwidth = JSON.parse((this.templateData?.tmplDisplaySettings))?.width;
  const width = !!tmplwidth ? `${tmplwidth}mm` : 'auto';
  const element = this.elementRef.nativeElement.querySelector('.thermal-print-width');
  element.style.setProperty('width', width, 'important');
}

changeTemplate() {
  this.changeThemeNotifyDialog = true;
}
  get fval(): { [key: string]: AbstractControl } { return this.templateForm.controls; }
  get fval1(): { [key: string]: AbstractControl } { return this.fontdialogForm.controls; }
  get apiUrl() { return environment.baseUrl; }

generateForm(): FormGroup {
  const baseForm = this.fb.group({});
  baseForm.addControl("fieldsSelect", new FormControl(null));
  baseForm.addControl("sumType", new FormControl(null));
  baseForm.addControl("title", new FormControl(null, [Validators.maxLength(50)]));
  this.sumSrvc.list(`${this.apiUrl}/patSum/${this.tenandId}/${this.branchId}/fields`).pipe(takeUntil(this.unsubscribe$)).subscribe(data => {

    this.fields = data;
    this.multiSelectFields = this.fields.filter(t => t.tblName && t.tblName.toLocaleLowerCase().indexOf("patientregistration") > -1);
    this.fields.forEach(y => {
      baseForm.addControl(y.fieldName, new FormControl(null));
    });
    this.detForm = baseForm;
    return baseForm;
  }, (error) => {
    this.detForm = baseForm;
    return baseForm;
  }, () => {
    this.fetchPatDetails();
  }
  );
  return baseForm;
}

fetchPatDetails(): void {
  if(this.regId !== null && this.regId !== undefined) {
  this.patRegSrvc.getById("patientregistrationmst/" + this.tenandId + '/' + this.branchId + '/' + this.regId).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    this.patDet = data;
    this.patDet.dob = this.datePipe.transform(data.dob, 'mediumDate');
    this.multiSelectFields.forEach(det => {
      if (this.patDet[det.columnName] != null && this.patDet[det.columnName] != undefined)
        this.detForm.controls[det.fieldName].setValue(this.patDet[det.columnName]);
    });
  }, (error) => {

  }, () => {

  });
}
    else
return;
  }

ngOnDestroy(): void {
  this.itemvalue = this.itemvalue?.map((x, index) => {
    x.displayeditor = false;
    x.displaytext = false;
    return { ...x }
  })
}

onChange(args: any) {
  this.selectsummarymst = args;
  this.editDischargeData = null;
  this.templateData = this.selectsummarymst[0]?.data;
  this.editdata(args[0]?.data);
  this.editDischargeData = null;
}


  async editdata(data) {
    if(data==undefined){return false;}
  this.templateForm.controls['templatename'].setValue(data?.tmplName);
  this.templateForm.controls['tmplCommonFlag'].setValue(data?.tmplCommonFlag == 'Y' ? true : false);
  this.templateForm.controls['tmplReportHeader'].setValue(data?.tmplReportHeader);
  this.templateForm.controls['tmplReportFooter'].setValue(data?.tmplReportFooter);
  this.templateForm.controls['tmplDisplayDept'].setValue(data?.tmplDisplayDept == 'Y' ? true : false);
  this.templateForm.controls['tmplDisplayPhy'].setValue(data?.tmplDisplayPhy == 'Y' ? true : false);
  this.templateForm.controls['tmplDisplaySettings'].setValue(JSON.parse(data?.tmplDisplaySettings));
  this.templateForm.controls['tmplActiveFlag'].setValue(data?.tmplActiveFlag == 'Y' ? true : false);
  var template = {
    ...JSON.parse(data?.tmplDisplaySettings),
    temp_title: JSON.parse(data?.tempTitle),
    page_title: JSON.parse(data?.pageTitle),
    footer: JSON.parse(data?.footer)
  }
  this.templateForm.controls['bgColor'].setValue(template?.bgColor);
  this.templateForm.controls['imagewidth'].setValue(template?.imagewidth);
  this.templateForm.controls['ps'].setValue(template?.ps);
  this.templateForm.controls['orientation'].setValue(template?.orientation);
  this.templateForm.controls['tm'].setValue(template?.tm);
  this.templateForm.controls['bm'].setValue(template?.bm);
  this.templateForm.controls['lm'].setValue(template?.lm);
  this.templateForm.controls['rm'].setValue(template?.rm);
  this.templateForm.controls['labelColor'].setValue(template?.labelColor);
  this.templateForm.controls['fontSize'].setValue(template?.fontSize);
  this.templateForm.controls['fontfamily'].setValue(template?.fontfamily);
  this.templateForm.controls['bodylayout'].setValue(template?.bodylayout);
  this.templateForm.controls['temptype'].setValue(template?.temptype);
  this.templateForm.controls['watermark'].setValue(template?.temp_title?.watermark ? true : false);
  this.templateForm.controls['watermarkPosition'].setValue(template?.temp_title?.watermarkPosition ? template?.temp_title?.watermarkPosition : 'center end');

  this.pageTitleSetttings = template?.page_title,
    this.pageTitleList = template?.page_title?.fields;
  this.pageTitleList = this.pageTitleList?.map(x => {
    this.replaceHeaderValueCall.emit(x);
    this.sleep(1000);
    x = this.replacedHeaderValue;
    return { ...x }
  });
  (this.templateForm.get('bodyItemLines') as FormArray).clear();
  this.bodyItemLines = this.templateForm.get('bodyItemLines') as FormArray;
  var bodyitmes = data?.dischargeTmplDet;
  this.itemvalue = [];
  bodyitmes?.filter(async (x, index) => {
    var headerjson = {
      "itemfontfamily": JSON.parse(x.rowSettings)?.header?.fontstyle?.fontfamily,
      "itemfontcolor": JSON.parse(x.rowSettings)?.header?.fontstyle?.fontColor,
      "itemfontsize": JSON.parse(x.rowSettings)?.header?.fontstyle?.fontSize,
      "itemposition": JSON.parse(x.rowSettings)?.header?.fontstyle?.textAlign,
    }
    var valuejson = {
      "itemfontfamily": JSON.parse(x.rowSettings)?.value?.fontstyle?.fontfamily,
      "itemfontcolor": JSON.parse(x.rowSettings)?.value?.fontstyle?.fontColor,
      "itemfontsize": JSON.parse(x.rowSettings)?.value?.fontstyle?.fontSize,
      "itemposition": JSON.parse(x.rowSettings)?.value?.fontstyle?.textAlign,
    }

    var pagecount;
    if (template?.temp_title?.rowCount != null && template?.temp_title?.rowCount != "") {
      pagecount = Number(template.temp_title.rowCount)
    } else {
      pagecount = 10;
    }
    var count = pagecount;
    var pagebreaks = "<p style='page-break-after:always;'></p>";
    var footerpagenumber = "<footer>{pagenumber} To be Continued</footer>";
    if (x.rowDefaultValue.includes('{currentdate}')) {
      this.replaceHeaderValueCall.emit(x.value);
      x.rowDefaultValue = this.replacedHeaderValue;
    }
    if (x.rowDefaultValue.includes('{currenttime}')) {
      this.replaceHeaderValueCall.emit(x.value);
      x.rowDefaultValue = this.replacedHeaderValue;
    }

    if (String(x.rowDefaultValue).includes('<table')) {
      var disSummary, dissummary2, headerindex, tableTbodyTrStart, footerindex, endindex;

      disSummary = x.rowDefaultValue;
      headerindex = x.rowDefaultValue.indexOf('<thead>');
      tableTbodyTrStart = x.rowDefaultValue.indexOf('<tr class="tableTbodyTrStart');
      footerindex = x.rowDefaultValue.indexOf('</tbody>');
      endindex = x.rowDefaultValue.indexOf('</html>');
      disSummary = this.sliceval(x.rowDefaultValue, 0, tableTbodyTrStart);
      dissummary2 = this.sliceval(x.rowDefaultValue, footerindex, endindex);

      this.dissumamry1 = [];
      this.dissumamry2 = [];
      count = pagecount;
      var finalsummary, lastonw;
      const mainTable = String(x.rowDefaultValue).includes('mainTableThead');
      const taxTable = String(x.rowDefaultValue).includes('taxTable');
      const advanceStart = String(x.rowDefaultValue).includes('advanceTableStart');
      let currentTableData;
      if (mainTable) {
        currentTableData = this.billData?.billDetail;
      } else if (taxTable) {
        currentTableData = this.billData?.taxDetail;
      } else if(advanceStart){
        currentTableData = this.billData?.advanceDetail;
      }else {
        currentTableData = [];
      }

      if (!!currentTableData && currentTableData.length > 0) {
        for (var k = 0; k < currentTableData?.length; k++) {
          const slicedValue = this.sliceval(x.rowDefaultValue, tableTbodyTrStart, footerindex)
          const tableDet = currentTableData[k];
          this.replaceTableValueCall.emit({ string: slicedValue, index: k, tableDet: tableDet });
          if (k + 1 == count) {
            this.dissumamry1 = this.dissumamry1 + this.replacedTableValue;
            finalsummary = disSummary.concat(this.dissumamry1.toString());
            lastonw = finalsummary.concat(dissummary2.toString());

            if (this.dissumamry2 == "") {
              this.dissumamry2 = lastonw + this.replacepagenumber(footerpagenumber, 0);
              this.pagenumber += 1;
            }
            else {
              this.dissumamry2 = this.dissumamry2 + pagebreaks + lastonw + this.replacepagenumber(footerpagenumber, 0);
              this.pagenumber += 1;
            }
            this.dissumamry1 = [];
            count += pagecount;
          }
          else if (k + 1 == currentTableData.length) {
            this.dissumamry1 = this.dissumamry1 + this.replacedTableValue;
            finalsummary = disSummary.concat(this.dissumamry1.toString());
            lastonw = finalsummary.concat(dissummary2.toString());
            if(lastonw.includes('advanceTableStart')){
              this.replaceDetailsValueCall.emit(lastonw);
              lastonw = this.replacedDetailsValue;
            }
            if (this.dissumamry2 == "") {
              this.dissumamry2 = lastonw;
            }
            else {
              this.dissumamry2 = this.dissumamry2 + pagebreaks + lastonw;
            }
            this.dissumamry1 = [];
          }
          else {
            if (this.dissumamry1.length == 0) {
              this.dissumamry1 = this.replacedTableValue;
            }
            else {
              this.dissumamry1 = this.dissumamry1 + this.replacedTableValue;
            }
          }
        }

      this.itemvalue.push({ value: this.dissumamry2, displayeditor: this.tableEditorCondition, displaytext: this.tableDisplayCondition });
      } else {
        if((mainTable || taxTable || advanceStart) && currentTableData!== undefined && currentTableData.length == 0){
          x.rowDefaultValue="";
        }
        this.replaceDetailsValueCall.emit(x.rowDefaultValue);
        this.dissumamry2 = this.replacedDetailsValue;
       this.itemvalue.push({ value: this.dissumamry2, displayeditor: this.detailsEditorCondition, displaytext: this.detailsDisplayCondition });
      }
      var headername = !!x?.rowHeader ? x?.rowHeader : x?.rowHeaderName
      this.bodyItemLines.push(this.fb.group({
        header: { itemvalue: headername, ...JSON.parse(x.rowSettings).header, ...headerjson },
        value: { itemvalue: this.dissumamry2, ...JSON.parse(x.rowSettings).value, ...valuejson }
      }));

    }
    else {
      var disSummary = x.rowDefaultValue;
      this.replaceDetailsValueCall.emit(disSummary);
      disSummary = this.replacedDetailsValue;
      this.itemvalue.push({ value: disSummary, displayeditor: this.detailsEditorCondition, displaytext: this.detailsDisplayCondition });
      var headername = !!x?.rowHeader ? x?.rowHeader : x?.rowHeaderName
      this.bodyItemLines.push(this.fb.group({
        header: { itemvalue: headername, ...JSON.parse(x.rowSettings).header, ...headerjson },
        value: { itemvalue: disSummary, ...JSON.parse(x.rowSettings).value, ...valuejson }
      }));

    }
  });
  this.itemBodyList = [...this.bodyItemLines.value.map((x, index) => {
    return {
      index: index, ...x
    }
  })];
  (this.templateForm.get('topHeaderLines') as FormArray).clear();
  const addressDetail = data?.branchWiseAddressDetail;
    
  if (!addressDetail || Object.keys(addressDetail).length === 0) {
    this.topHeaderLines = this.templateForm.get('topHeaderLines') as FormArray;
    this.topHeaderLines.clear();
  
    template?.temp_title?.topHeaderLines
      ?.filter(x => !!x.name)
      .forEach(x => {
        this.topHeaderLines.push(this.fb.group({
          name: x.name,
          value: x.value,
          fontsize: x.fontsize
        }));
      });
  
    this.FooterLines = this.templateForm.get('FooterLines') as FormArray;
    this.FooterLines.clear();
  
    template?.footer?.bottomLines
      ?.filter(x => !!x.name)
      .forEach(x => {
        this.FooterLines.push(this.fb.group({
          name: x.name,
          value: x.value,
          fontsize: x.fontsize
        }));
      });
  } else {
    this.topHeaderLines = this.templateForm.get('topHeaderLines') as FormArray;
    this.topHeaderLines.clear();
  
    const headerLines = JSON.parse(addressDetail.templateHeaderConfig || '[]');
    headerLines.forEach((line: any) => {
      this.topHeaderLines.push(this.fb.group({
        name: line.name,
        value: line.value,
        fontsize: line.fontsize
      }));
    });
  
    this.FooterLines = this.templateForm.get('FooterLines') as FormArray;
    this.FooterLines.clear();
  
    const footerLines = JSON.parse(addressDetail.templateFooterConfig || '[]');
    footerLines.forEach((line: any) => {
      this.FooterLines.push(this.fb.group({
        name: line.name,
        value: line.value,
        fontsize: line.fontsize
      }));
    });
  }
  if(!!template?.temp_title){
    delete template?.temp_title['topHeaderLines']
    for(let x of this.objectKeys(template?.temp_title)){  
      try{
        if(!!this.templateForm.controls[x])
          this.templateForm.controls[x].setValue(template?.temp_title[x])
      }catch(Execption){}
    }
  }
  if (!!template?.footer) {
    delete template?.footer['bottomLines']
    for (let x of this.objectKeys(template?.footer)) {
      try {
        if (!!this.templateForm.controls[x])
          this.templateForm.controls[x].setValue(template?.footer[x])
      } catch (Execption) { }
    }
  }
  this.onPreview();
}
onprint() {
  this.templatePreview = this.templateForm.value;
}
setformtewoValue(control, val) {
  this.fontdialogForm.controls[`${control}`].setValue(val);
}
  async onPreview() {
  this.templatePreview = this.templateForm.value;
  this.config.styles.push(`@media print {
                @page
                {
                  margin-top: ${this.templatePreview?.tm}px !important;
                }
              }
      `);

  await this.sleep(1000)
  this.pageTitleList.filter(async (x, index) => {
    var headerval = { ...x.headerstyle, elementVal: null };
    var headerelem = document.getElementById("pageheaderhead" + index) as HTMLElement;
    if (!!headerelem) {
      headerval.elementVal = headerelem;
      this.onFontDialogValueChanged(headerval);
    }
    var bodyval = { ...x.valuestyle, elementVal: null };
    var bodyelem = document.getElementById("pageheadervalue" + index) as HTMLElement;
    if (!!bodyelem) {
      bodyval.elementVal = bodyelem;
      this.onFontDialogValueChanged(bodyval);
    }
  });
  this.templatePreview?.bodyItemLines?.forEach(async (x, index) => {
    var headerval = { ...x.header.fontstyle, elementVal: null };
    var headerelm = document.getElementById("itembodyheader" + index) as HTMLElement;
    if (!!headerelm) {
      headerval.elementVal = headerelm;
      this.onFontDialogValueChanged(headerval);
    }
    var bodyval = { ...x.value.fontstyle, elementVal: null };
    var bodyelem = document.getElementById("itembodyvalue" + index) as HTMLElement;
    if (!!bodyelem) {
      bodyval.elementVal = bodyelem;
      this.onFontDialogValueChanged(bodyval);
    }
  });
  this.setWidth();
}
sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
onFontDialogValueChanged(data) {
  if (!!data && !!data.elementVal)
    this.setfontstyle(data);
  if (!!this.commonStylechange) {
    this.templatePreview?.bodyItemLines?.forEach(async (x, index) => {
      if (this.commonStylechange == "header") {
        var headerval = this.fontdialogForm.value;
        headerval.elementVal = document.getElementById("itembodyheader" + index) as HTMLElement;
        this.setfontstyle(headerval);
      }
      if (this.commonStylechange == "value") {
        var bodyval = this.fontdialogForm.value;
        bodyval.elementVal = document.getElementById("itembodyvalue" + index) as HTMLElement;
        this.setfontstyle(bodyval);
      }
    });
  }
}
setfontstyle(data) {
  const flags = RendererStyleFlags2.DashCase | RendererStyleFlags2.Important;
  this.renderer.setStyle(data?.elementVal, 'color', data?.fontColor, flags);
  this.renderer.setStyle(data?.elementVal, 'font-size', data?.fontSize + 'pt', flags);
  this.renderer.setStyle(data?.elementVal, 'font-family', data?.fontfamily, flags);
  this.renderer.setStyle(data?.elementVal, 'font-weight', data?.isBold ? 'bold' : 'normal', flags);
  this.renderer.setStyle(data?.elementVal, 'font-style', data?.isItalic ? 'italic' : 'normal', flags);
  this.renderer.setStyle(data?.elementVal, 'text-decoration', data?.isUnderline ? 'underline' : 'none', flags);
  this.renderer.setStyle(data?.elementVal, 'text-align', data?.textAlign, flags);
  this.renderer.setStyle(data?.elementVal, 'line-height', data?.textheight, flags);
  this.renderer.setStyle(data?.elementVal, 'padding-left', data?.indent + "px", flags);
}
fontdialog(event, commonStylechange ?) {
  if (!!commonStylechange)
    this.commonStylechange = commonStylechange;
  else
    this.commonStylechange = null;
  var existdata = JSON.parse(JSON.stringify(event?.style));
  var res = existdata?.color.replace("rgb", '').replace("(", '').replace(')', '').split(",").map(Number);

  this.fontdialogForm.setValue({
    "elementVal": event,
    "fontfamily": this.commonSettings.fontfamily,
    "fontColor": rgbToHex(res[0], res[1], res[2]),
    "fontSize": parseInt(existdata?.fontSize.split("pt")[0]),
    "isBold": !!existdata?.fontWeight ? existdata?.fontWeight == "bold" ? true : false : false,
    "isItalic": !!existdata?.fontStyle ? existdata?.fontStyle == "italic" ? true : false : false,
    "isUnderline": !!existdata?.textDecoration ? existdata?.textDecoration == "underline" ? true : false : false,
    "linespace": !!existdata?.lineHeight ? parseFloat(existdata?.lineHeight) : 1,
    "textAlign": !!existdata?.textAlign ? existdata?.textAlign : "left",
    "outdent": !!existdata.paddingLeft ? (parseInt(existdata.paddingLeft.split("px")[0])) : '0',
    "indent": !!existdata.paddingLeft ? (parseInt(existdata.paddingLeft.split("px")[0])) : '0',
    "textheight": !!existdata?.lineHeight ? parseFloat(existdata?.lineHeight) : 1,
  });
  var returndata = this.fontdialogForm.value;
  delete returndata['elementVal'];
  return returndata;
}
setpragraph(type, value) {
  const flags = RendererStyleFlags2.DashCase | RendererStyleFlags2.Important;
  var data_ = this.fontdialogForm.controls['elementVal'].value;
  var existdata = JSON.parse(JSON.stringify(data_?.style));
  var margindata = 0;
  if (type == "indent") {
    margindata = 5;
    if (existdata.paddingLeft != "")
      margindata = (parseInt(existdata.paddingLeft.split("px")[0]) + 5)
    this.renderer.setStyle(this.fval1?.elementVal.value, 'padding-left', margindata + "px", flags);
  }
  else if (type == "outdent") {
    margindata = parseInt(existdata.paddingLeft.split("px")[0]);
    if (margindata >= 0)
      margindata = margindata - 5;
    else
      margindata = margindata - 5;
    this.renderer.setStyle(this.fval1?.elementVal.value, 'padding-left', margindata + "px", flags);
  }
  if (!!this.commonStylechange)
    this.fontdialogForm.controls['indent'].setValue(margindata);
}
checkpageTitleVisible() {
  var data = this.pageTitleList?.find(x => x.display == true)
  if (!!data)
    return true;
  else
    return false;
}

valueChange(value, event, index) {
  this.bodyItemLines = this.templateForm.get('bodyItemLines') as FormArray;
  var val = this.bodyItemLines.controls[index].value;
  val.value.itemvalue = value
  this.bodyItemLines.controls[index].setValue(val);
}

bodyEntermouse(type, i) {
  this.itemvalue = this.itemvalue?.map((x, index) => {
    x.displayeditor = index == i ? true : false;
    x.displaytext = true;
    return { ...x }
  })
}
downloadFile() {

  var pageTitle = "ssss"
  var styles = '';
  this.config.stylesheets.filter(x => {
    styles = styles + `<link rel='stylesheet' href='${x.href}'> `;
  });
  var printContent = `
        <head>
        <title>${pageTitle}</title>
            ${styles}
        </head>
        <body>
          <div class="print-content">
            ${this.printcontent.nativeElement.innerHTML}
          </div>
        </body> `;
  this.downloadHtml = printContent;

  html2canvas(this.downloadpdf.nativeElement).then(canvas => {
    // Few necessary setting options
    var imgWidth = 208;
    var pageHeight = 295;
    var imgHeight = (canvas.height * imgWidth) / canvas.width;
    var heightLeft = imgHeight;

    const contentDataURL = canvas.toDataURL("image/png");
    let pdf = new jspdf("p", "mm", "a4"); // A4 size page of PDF
    var position = 0;
    pdf.addImage(contentDataURL, "PNG", 0, position, imgWidth, imgHeight);
    pdf.save("MYPdf.pdf"); // Generated PDF
  });

}

sliceval(val, start, end) {
  return val.slice(start, end);
}

replacepagenumber(string, inx) {
  if (!!string) {
    string = string.replace((new RegExp("{pagenumber}", "g")), this.pagenumber)
    return string;
  }
}

shouldInlineBlock(item:any, index:any){
return item?.value?.itemvalue?.includes('advanceTable');
}


popoverclose() {
  if (this.popovers) {
    this.popovers.forEach(popover => {
      popover.hide();
    });
  }
  this.popover.hide();
}

getMailData(event) {
  if (this.patientDetails.email) {
    if (this.mailActivationFlag) {
      if (this.mailCreditBalance) {
        let data1 = document.getElementById('tempprintpreview');
        this.pdfBlobSrvc.downloadPDFForHims(data1, this.patientName, this.regId, this, this.psDetails, `_OP_Bill_${this.billNumber}`, 'OP', 'OP_Bill', 'Mail', event);
      }
      else {
        this.isNoMailCreditBal = true;
      }
    }
    else {
      this.isMailnotActivated = true;
    }
  }
  else {
    this.isMailnotExists = true;
    setTimeout(() => {
      this.isMailnotExists = false;
    }, 2000);
  }
}

sendMail(mailContent) {

  let resultContent = `Dear ${this.patientDetails.firstname}, Please click on the link below to view your OP e-bill.`;
  const postData = {
    mail_datas: {
      message: {
        html_content: `<html><head><title></title></head><body><p>${resultContent}</p><a href="${mailContent.uri}">OP Bill</a></body></html>`,
        subject: `Reg-IP Bill-${this.patientDetails.regNum}-${this.patientDetails.firstname}`,
        from_mail: "info@ezovion.co.in",
        from_name: this.customerName,
        reply_to: "info@ezovion.co.in",
        to_recipients: [{ email_id: this.patientDetails.email, name: this.patientDetails.firstname }],
      },
    },
  };

  this.mailSrvc.post(postData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    var data = data;
  }, (error) => {
    this.mailErrMsg = true;
    setTimeout(() => {
      this.mailErrMsg = false;
    }, 3000);
  }, () => {
    this.mailSuccessMsg = true;
    setTimeout(() => {
      this.mailSuccessMsg = false;
    }, 3000);
    this.mailConfirmation();
  });
}

mailConfirmation() {
  let resultContent = `Dear ${this.patientDetails.firstname}, Please click on the link below to view your OP e-bill.`;
  let smstrackingDetails = {
    referencefrom: 'OP_Bill',
    referencenum: this.patientDetails.regNum,
    mobileNumber: this.patientDetails.mobile,
    message: resultContent,
    MailUnit: 1,
    senderId: 'EZOHMS',
    status: "ok",
    createdIp: null,
    createdby: parseInt(localStorage.getItem("userId")),
    createddate: this.datesrcv.currentDate(),
    tenantId: this.tenandId,
    branchId: this.branchId
  }


  this.rolesService.create(`${this.apiUrl}/smstrackingdet/${this.tenandId}/${this.branchId}/sendMail`, smstrackingDetails).subscribe(data => {
  }, (error) => {

  }, () => {

  });

}
getReferrence() {
    return this.upireferrence ||
      this.cardreferrence ||
      this.chequereferrence ||
      this.netBankingreferrence ||
      '';
  }
}

export function rgbToHex(r: number, g: number, b: number): string {
  if (!!r && !!g && !!b)
    return `#${[r, g, b].map(x => x.toString(16).padStart(2, "0")).join("")}`;
  else
    return '#333333'
}

